import type { IMenu } from "#/constants";
import { api, auth, cart } from "#/utils";
import { useLoading } from "#/utils/context/loading";
import { Footer, Header } from "@monta/components";
import { Outlet, useLocation } from "@monta/router-react";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import styles from "./layout.module.scss";

export const getMenuItems = async (userTypeId: number = 1) => {
  return api
    .get("/infrastructure/getMenu", {
      params: { b2c: true, userSubTypeId: userTypeId },
    })
    .then((res) => {
      return JSON.parse(res?.data?.landingMenu || "")?.linkList as IMenu[];
    })
    .catch(() => {
      return Promise.resolve([] as IMenu[]);
    });
};

const Layout = () => {
  const { showLoading, hideLoading } = useLoading();
  const loginInfo = auth.useAuth();
  const items = cart.useCartDetailedItems();
  const [userTypeId, setUserTypeId] = useState<number>();
  const { data: menuItems } = useQuery(
    ["get-menu", userTypeId],
    () => {
      showLoading();
      return getMenuItems(userTypeId).finally(hideLoading);
    },
    {
      enabled: !!userTypeId,
      initialData: [],
    },
  );

  const location = useLocation();

  useEffect(() => {
    if (loginInfo && loginInfo.id) {
      setUserTypeId(loginInfo.subTypeId);
    } else {
      if (items && items.length > 0) {
        setUserTypeId(items[0].buyerTypeId);
      }
    }
  }, [loginInfo, items]);

  return (
    <div dir="rtl" id="app" className={styles["layout"]}>
      <Header
        api={api as any}
        auth={auth as any}
        cart={cart as any}
        menuItems={menuItems as IMenu[]}
        route={location.pathname}
      />
      <main>
        <Outlet />
      </main>
      {!auth.isLoggedIn && (
        <Footer
          auth={auth}
          userSubTypeId={loginInfo ? loginInfo.subTypeId : 1}
        />
      )}
    </div>
  );
};
export default Layout;
